export default __webpack_public_path__ + "static/media/Live_Agnitio_Logo_Stacked_White_RGB.e67c4136.svg";